import { type Dispatch, type SetStateAction, createContext } from 'react';

import type { BaseDictionaryResponse } from '@entities/dictionaries';

import type { TypesSelfEmploymentDataResponse } from '../../api';
import { type FormDetailsArgs } from '../helpers/get-form-update';

export const SubmitContext = createContext<{
  isLoading: boolean;
  hasError: boolean;
  resetError: () => void;
  handleSubmit: (...args: FormDetailsArgs) => Promise<void>;
  passportChangeReasonDictionary: BaseDictionaryResponse;
  relationshipTypeDictionary: BaseDictionaryResponse;
  typesSelfEmploymentDictionary: TypesSelfEmploymentDataResponse;
  setPassportChangeReasonDictionary: Dispatch<
    SetStateAction<BaseDictionaryResponse>
  >;
  setRelationshipTypeDictionary: Dispatch<
    SetStateAction<BaseDictionaryResponse>
  >;
  setTypesSelfEmploymentDictionary: Dispatch<
    SetStateAction<TypesSelfEmploymentDataResponse>
  >;
}>({
  isLoading: false,
  hasError: false,
  resetError: () => null,
  handleSubmit: () => Promise.resolve(),
  passportChangeReasonDictionary: { data: [] },
  relationshipTypeDictionary: { data: [] },
  typesSelfEmploymentDictionary: { data: [] },
  setPassportChangeReasonDictionary: () => {},
  setRelationshipTypeDictionary: () => {},
  setTypesSelfEmploymentDictionary: () => {},
});
